import { Pipe, PipeTransform } from '@angular/core';
import { PriceDisplayMode } from '../../enums/price-display-mode.enum';
import { PriceDisplayService } from '../../../car/shared/price-display.service';
import { CurrencyPipe, DecimalPipe } from '@angular/common';

@Pipe({
  standalone: false,
  name: 'priceFormatter'
})
export class PriceFormatterPipe implements PipeTransform {
  private conversionRate: number;
  private currencyCode: string;
  
  constructor(
    private priceDisplayservice: PriceDisplayService,
    private currencyPipe: CurrencyPipe,
    private decimalPipe: DecimalPipe
  ) {
    this.conversionRate = priceDisplayservice.getConversionRate();
    this.currencyCode = priceDisplayservice.getCurrencyCode();
  }

  transform(value: any, displayAs?: 'number' | 'currency', digits?: string): string {
    let displayMode = this.priceDisplayservice.getPriceDisplayMode();

    if (displayMode === PriceDisplayMode.Points) {
      return this.ConvertDollarsToPoints(value);
    }

    if (displayMode === PriceDisplayMode.Dollars && displayAs === 'currency'){
      return this.ConvertToDollars(value, digits);
    }

    return this.decimalPipe.transform(value, digits);
  }

  private ConvertDollarsToPoints(amount: number): string {
    const points = amount && this.conversionRate > 0
      ? Math.ceil(amount / this.conversionRate)
      : null;
    return this.decimalPipe.transform(points)
  }

  private ConvertToDollars(amount: number, digits: string): string {
    const dollars = this.currencyPipe.transform(amount, this.currencyCode, 'symbol', digits);
    return dollars;
  }
}
